<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/wGWIEx/tc-custom/9781250256720.jpg?1730583379515" alt="This image is the cover for the book Proof of Conspiracy"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Proof of Conspiracy
      </h1>
      <p class="bookDescription body article font2">
        <p><b>Instant<i> New York Times</i> Bestseller<br/><br/>"A richly documented indictment of power and corruption." </b><b>—<i>Kirkus Reviews </i></b><br/><b><br/>Through diligent research, Seth Abramson exposes a story that U.S. media has largely missed: a pre-election geopolitical conspiracy involving Saudi Arabia, the United Arab Emirates, Israel, and Russia that sought to put Trump in the White House—and succeeded. </b><br/><br/>In late 2015, convicted pedophile, international dealmaker, and cooperating witness in Special Counsel Robert Mueller’s Russia investigation George Nader convened a secret meeting aboard a massive luxury yacht in the Red Sea. Nader pitched Saudi Crown Prince Mohammed bin Salman, Emirati Crown Prince Mohammed bin Zayed, Egyptian President Abdel Fattah el-Sisi and other Middle Eastern leaders a plan for a new pro-U.S., pro-Israel alliance of Arab nations that would fundamentally alter the geopolitics of the Middle East while marginalizing Iran, Qatar, and Turkey. To succeed, the plan would need a highly placed American politician willing to drop sanctions on Russia so that Vladimir Putin would in turn agree to end his support for Iran. They agreed the perfect American partner was Donald Trump, who had benefited immensely from his Saudi, Emirati, and Russian dealings for many years, and who, in 2015, became the only U.S. presidential candidate to argue for a unilateral end to Russian sanctions and a far more hostile approach to Iran.<br/><br/>So begins <i>New York Times</i> bestselling author Seth Abramson’s explosive new book <i>Proof of Conspiracy: How Trump's International Collusion Threatens American Democracy</i>, a story of international intrigue whose massive cast of characters includes Israeli intelligence operatives, Russian oligarchs, Saudi death squads, American mercenary companies, Trump’s innermost circle, and several members of the Trump family as well as Trump himself—all part of a clandestine multinational narrative that takes us from Washington, D.C. and Moscow to the Middle Eastern capitals of Riyadh, Abu Dhabi, Jerusalem, Cairo, Tehran, and Doha. <i>Proof of Conspiracy </i>is a chilling and unforgettable depiction of the dangers America and the world now face.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Seth Abramson
      </h2>
      
      <p class="authorDescription body article">Seth Abramson is a former criminal defense attorney and criminal investigator who teaches digital journalism, legal advocacy, and cultural theory at the University of New Hampshire. A regular political and legal analyst on CNN and the BBC during the Trump presidency, he is the author of eleven books and editor of five anthologies. Abramson is a graduate of Dartmouth College, Harvard Law School, the Iowa Writers’ Workshop, and the PhD program in English at University of Wisconsin-Madison. He lives in New Hampshire with his wife and two one-year-old rescue hounds, Quinn and Scout. Read more about him at SethAbramson.net.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      St. Martin's Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5bddbcb7